<ng-container *transloco="let t;">
  <div class="onboarding-bg">
    <img src="./assets/img/onboarding-f2p/onboarding-bg.png" />
  </div>
  <div class="loading-overlay" *ngIf="wallet==undefined || isGenerating || isDoneAlready">
    <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin" *ngIf="!isGeneratingError && !isDoneAlready"></fa-icon>
    <p *ngIf="isGeneratingError">{{t('errorMsg.refreshPage')}}</p>
    <p *ngIf="isDoneAlready">{{t('errorMsg.syntethicAlreadyHatched')}}</p>
    <div class="actions-block" *ngIf="isDoneAlready">
      <div class="button-gradient" (click)="openGame()">
        <img src="./assets/img/Icon/icon-btn-play-light.svg" class="icon-btn-play" />{{t('shared.startPlaying')}}
      </div>
    </div>
  </div>
  <div class="f2p-new-bg">
    <div class="f2p-new-section">
      <div class="progress-container">
        <div class="progress-card">
          <img src="/assets/img/onboarding-f2p/prof-light.png" class="progress-card-prof" />
          <div class="progress-content">
            <div class="progress-text step-1" *ngIf="stepProcess==0 && !isSummoned">
              <h1 class="uppercase">{{t('onboarding.summonSynthetic')}}</h1>
              <p>{{t('onboarding.syntheticPrimarySecondaryDesc')}}</p>
            </div>
            <div class="progress-text step-2" *ngIf="stepProcess==0 && isSummoned">
              <h1>{{t('onboarding.eggsReady')}}</h1>
              <p>{{t('onboarding.beautyfulBabies')}}</p>
            </div>
            <div class="progress-text step-3" *ngIf="stepProcess==1">
              <h1>{{t('onboarding.babiesHatched')}}</h1>
              <p>{{t('onboarding.eggsHatchingSoon')}}</p>
              <div class="progress-bar-container">
                <div class="progress-bar">
                  <span class="progress-bar-fill" [style]="'width: ' + progressStep + '%;'"></span>
                </div>
                <!--<span class="progress-step">{{progressStep}}/100</span>-->
              </div>
            </div>
            <div class="progress-text step-3" *ngIf="stepProcess==2">
              <h1>{{t('shared.congratulations')}}</h1>
              <p>{{t('onboarding.egsHatched')}}</p>
            </div>
            <div class="actions-block" *ngIf="stepProcess==0">
              <div class="button-gradient" (click)="getKryptomons()" *ngIf="!isSpinning && !isSummoned">
                {{t('onboarding.summonNow')}}</div>
              <div class="button-gradient" (click)="triggerHatch()" *ngIf="!isSpinning && isSummoned">
                {{t('onboarding.hatchYourKryptomon')}}
              </div>
              <div class="button-gradient" *ngIf="isSpinning">
                <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
              </div>
            </div>
            <div class="actions-block" *ngIf="stepProcess==1">
              <div class="button-grey"><img src="./assets/img/Icon/icon-btn-play-gray.svg"
                  class="icon-btn-play" />{{t('shared.startPlaying')}}</div>
            </div>
            <div class="actions-block" *ngIf="stepProcess==2">
              <div class="button-gradient" (click)="openGame()"><img src="./assets/img/Icon/icon-btn-play-light.svg"
                  class="icon-btn-play" />{{t('shared.startPlaying')}}</div>
            </div>
          </div>
          <div class="progress-bredcrumbs">
            <div class="progress-bredcrumbs-item progress-bredcrumbs-summon">
              <p class="progress-bredcrumbs-summon-text">{{t('shared.summon')}}</p>
              <img src="./assets/img/onboarding-f2p/Step-Egg-active.svg" />
            </div>
            <div class="progress-bredcrumbs-item progress-bredcrumbs-hatch">
              <p class="progress-bredcrumbs-hatch-text">{{t('shared.hatch')}}</p>
              <img src="./assets/img/onboarding-f2p/Step-Hatch.svg" *ngIf="stepProcess<1" />
              <img src="./assets/img/onboarding-f2p/Step-Hatch-active.svg" *ngIf="stepProcess>=1" />
            </div>
            <div class="progress-bredcrumbs-item progress-bredcrumbs-play">
              <p class="progress-bredcrumbs-play-text">{{t('shared.play')}}</p>
              <img src="./assets/img/onboarding-f2p/Step-Play.svg" *ngIf="stepProcess<2" />
              <img src="./assets/img/onboarding-f2p/Step-Play-active.svg" *ngIf="stepProcess==2" />
            </div>
          </div>
        </div>
      </div>
      <div class="cards-container" #scrollableOthers [ngClass]="{'carousel-step':stepProcess>=1}">
        <div class="eggs-card-container" *ngIf="stepProcess==0">
          <div class="egg-card" *ngFor="let eg of eggsGenerated; let i = index" id="otherKryptomon">
            <img src="./assets/img/Icon/Starter.png" class="starter-icon" *ngIf="!eg.isLoading" />
            <img src="{{eg.img}}" class="egg-img" />
            <div class="egg-card-content">
              <div class="egg-card-content-loading" *ngIf="!eg.isLoading && !eg.loadingDone">
                <hr>
              </div>
              <div class="egg-card-content-loading" *ngIf="eg.isLoading">
                <img src="./assets/img/onboarding-f2p/loading.png" [ngClass]="{'fa-spin':eg.isLoading}" />
              </div>
              <div class="egg-card-content-details" *ngIf="!eg.isLoading && eg.loadingDone">
                <div class="egg-card-content-details-ranking">
                  <div class="Stars" style="--rating: {{eg.starValue}}"></div>
                  <span>{{eg.tierName}}</span>
                </div>
                <div class="egg-card-content-details-items">
                  <div class="egg-card-content-details-item">
                    <img src="{{eg.mainElementImage}}" />
                    <div class="egg-card-content-details-item-text">
                      <p>{{t('shared.main')}}</p>
                      <p>{{eg.mainElement}}</p>
                    </div>
                  </div>
                  <div class="egg-card-content-details-item">
                    <img src="{{eg.specialityImage}}" />
                    <div class="egg-card-content-details-item-text">
                      <p>{{t('shared.speciality')}}</p>
                      <p>{{eg.speciality}}</p>
                    </div>
                  </div>
                </div>
                <div class="egg-card-content-details-items">
                  <div class="egg-card-content-details-item">
                    <img src="{{eg.secondElementImage}}" />
                    <div class="egg-card-content-details-item-text">
                      <p>{{t('shared.secondary')}}</p>
                      <p>{{eg.secondElement}}</p>
                    </div>
                  </div>
                  <div class="egg-card-content-details-item gender-icon">
                    <img src="{{eg.genderIcon}}" />
                    <div class="egg-card-content-details-item-text">
                      <p>{{t('shared.gender')}}</p>
                      <p>{{eg.gender}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-container" *ngIf="stepProcess>=1">
          <div class="carousel-card" (swipeleft)="navigateLeft()" (swiperight)="navigateRight()">
            <div class="carousel-navigation left" (click)="navigateLeft()">
              <fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
            </div>
            <div class="carousel-navigation right" (click)="navigateRight()">
              <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
            </div>
            <div class="carousel-card-image-side">
              <img src="{{selectedCarouselKmon.img}}" class="egg-img hatchShake"
                *ngIf="!selectedCarouselKmon.hatched" />
              <img src="{{selectedCarouselKmon.kmonimg}}" class="kmon-img"
                [ngClass]="{'show':selectedCarouselKmon.hatched}" />
              <div class="egg-card-content-details">
                <div class="egg-card-content-details-ranking">
                  <div class="Stars" style="--rating: {{selectedCarouselKmon.starValue}}"></div>
                  <span>{{selectedCarouselKmon.tierName}}</span>
                </div>
                <div class="egg-card-content-details-items">
                  <div class="egg-card-content-details-item">
                    <img src="{{selectedCarouselKmon.mainElementImage}}" />
                    <div class="egg-card-content-details-item-text">
                      <p>{{t('shared.main')}}</p>
                      <p>{{selectedCarouselKmon.mainElement}}</p>
                    </div>
                  </div>
                  <div class="egg-card-content-details-item">
                    <img src="{{selectedCarouselKmon.specialityImage}}" />
                    <div class="egg-card-content-details-item-text">
                      <p>{{t('shared.speciality')}}</p>
                      <p>{{selectedCarouselKmon.speciality}}</p>
                    </div>
                  </div>
                </div>
                <div class="egg-card-content-details-items">
                  <div class="egg-card-content-details-item">
                    <img src="{{selectedCarouselKmon.secondElementImage}}" />
                    <div class="egg-card-content-details-item-text">
                      <p>{{t('shared.secondary')}}</p>
                      <p>{{selectedCarouselKmon.secondElement}}</p>
                    </div>
                  </div>
                  <div class="egg-card-content-details-item gender-icon">
                    <img src="{{selectedCarouselKmon.genderIcon}}" />
                    <div class="egg-card-content-details-item-text">
                      <p>{{t('shared.gender')}}</p>
                      <p>{{selectedCarouselKmon.gender}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-card-spells-side-wrapper">
              <div class="carousel-card-spells-side">
                <img src="{{selectedCarouselKmon.secondElementImage}}" class="element-image-abs" />
                <div class="carousel-card-spells-side-descriptions">
                  <div class="carousel-card-spells-side-descriptions-image">
                    <img src="./assets/img/spells/{{selectedSpellMain.element}}/{{selectedSpellMain.icon}}.png" />
                    <span>{{selectedSpellMain.name}}</span>
                  </div>
                  <div class="carousel-card-spells-side-descriptions-text">
                    <p>{{selectedSpellMain.description_long}}</p>
                  </div>
                </div>
                <div class="carousel-card-spells-side-selectors">
                  <div class="carousel-card-spells-side-selectors-item"
                    *ngFor="let sp of selectedCarouselKmon.spellsMain | spellsOnboardingFilter:selectedSpellMain.id"
                    (click)="selectMainSpell(sp)">
                    <img src="./assets/img/spells/{{sp.element}}/{{sp.icon}}.png" />
                    <span>{{sp.name}}</span>
                  </div>
                </div>
              </div>
              <div class="carousel-card-spells-side">
                <img src="{{selectedCarouselKmon.mainElementImage}}" class="element-image-abs" />
                <div class="carousel-card-spells-side-descriptions">
                  <div class="carousel-card-spells-side-descriptions-image">
                    <img src="./assets/img/spells/{{selectedSpellSecond.element}}/{{selectedSpellSecond.icon}}.png" />
                    <span>{{selectedSpellSecond.name}}</span>
                  </div>
                  <div class="carousel-card-spells-side-descriptions-text">
                    <p>{{selectedSpellSecond.description_long}}</p>
                  </div>
                </div>
                <div class="carousel-card-spells-side-selectors">
                  <div class="carousel-card-spells-side-selectors-item"
                    *ngFor="let sp of selectedCarouselKmon.spellsSecond | spellsOnboardingFilter:selectedSpellSecond.id"
                    (click)="selectSecondSpell(sp)">
                    <img src="./assets/img/spells/{{sp.element}}/{{sp.icon}}.png" />
                    <span>{{sp.name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="actions-block" *ngIf="stepProcess==0">
        <div class="button-outline" (click)="getKryptomons()" *ngIf="!isSpinning && !isSummoned">
          <img src="./assets/img/Icon/icon-btn-summon.svg" class="icon-btn-summon" />{{t('onboarding.summonNow')}}
        </div>
        <div class="button-outline" (click)="triggerHatch()" *ngIf="!isSpinning && isSummoned">
          <img src="./assets/img/Icon/icon-btn-hatch.svg"
            class="icon-btn-hatch" />{{t('onboarding.hatchYourKryptomon')}}
        </div>
        <div class="button-outline" *ngIf="isSpinning">
          <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
        </div>
      </div>
      <div class="actions-block" *ngIf="stepProcess==1">
        <div class="button-grey"><img src="./assets/img/Icon/icon-btn-play-gray.svg"
            class="icon-btn-play" />{{t('shared.startPlaying')}}
        </div>
      </div>
      <div class="actions-block" *ngIf="stepProcess==2">
        <div class="button-outline" (click)="openGame()"><img src="./assets/img/Icon/icon-btn-play.svg"
            class="icon-btn-play" />{{t('shared.startPlaying')}}</div>
      </div>
    </div>
  </div>
</ng-container>